<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_users"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Apporteur <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.clientable ? resource.clientable.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">


                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-toggle label="Délégué commercial" v-model="resource.is_dc"></form-toggle>

                                <entity
                                        v-model="entity"
                                        :default="resource.clientable_id"
                                        :defaultType="resource.clientable_type"
                                        label="Apporteur"
                                        :callback="updateEntity"
                                        :show-create="true"
                                        :show-company="true"
                                        :show-detail="false"></entity>
                                <form-text label="Code" v-model="resource.code"></form-text>

                                <div class="serevita-protrator-links" v-if="resource.links && resource.links.length > 0">

                                    <h2>Affaires rapportées</h2>


                                    <div class="datagrid light">
                                        <div class="datagrid-header">
                                            <div>
                                                <div> </div>
                                                <div> </div>
                                                <div><span>Nom du client</span></div>
                                                <div><span>Date du</span></div>
                                                <div><span>Date au</span></div>
                                                <div> </div>
                                            </div>
                                        </div>
                                        <div class="datagrid-body">
                                            <div v-for="item in resource.links">
                                                <div> </div>
                                                <div>
                                                    <i class="icon icon-file-group"></i>
                                                </div>
                                                <div class="name">
                                                    <strong>{{ item.clientable.name }}</strong>
                                                    <p>Code: <span class="code">{{ item.code }}</span></p>
                                                </div>
                                                <div class="date"><date v-model="item.pivot.date_start" :human="false"></date></div>
                                                <div class="date"><date v-model="item.pivot.date_end" :human="false"></date></div>
                                                <div> </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                              </fieldset>

                            </tab>
                            <tab name="Commissions">

                              <fieldset>
                                <h3>Contrats signés</h3>
                                <p class="headline"></p>

                                <div class="serevita-protrator-links" style="margin: 0;">

                                    <div class="datagrid light">
                                        <div class="datagrid-header">
                                            <div>
                                                <div> </div>
                                                <div> </div>
                                                <div><span>Nom du client</span></div>
                                                <div><span>Créé le</span></div>
                                                <div><span>Payé le</span></div>
                                                <div><span>Qui</span></div>
                                                <div><span>Status</span></div>
                                                <div> </div>
                                            </div>
                                        </div>
                                        <div class="datagrid-body">
                                            <div v-for="item in resource.commissions">
                                                <div> </div>
                                                <div>
                                                    <i class="icon icon-file-group"></i>
                                                </div>
                                                <div>
                                                    <strong>{{ item.firstname }} {{ item.lastname }}</strong>
                                                    <p>{{ item.reference }}</p>
                                                </div>
                                                <div>
                                                    <p><datetime v-model="item.created_at" :human="false"></datetime></p>
                                                </div>
                                                <div>
                                                    <p><datetime v-model="item.paied_at" :human="false"></datetime></p>
                                                </div>
                                                <div class="commissions">
                                                    <div v-for="commission in item.commissions" class="serevita-protrator-commission">
                                                        <div>{{ commission.type == 'commission_c' ? commission.referer : "Vente directe" }}</div>
                                                        <div>CHF {{ commission.amount|formatNumber }}</div>
                                                    </div>
                                                </div>
                                                <div class="status">
                                                    <span class="label published" v-if="item.status == 'completed'">Payé</span>
                                                    <span class="label soon" v-if="item.status != 'completed'">En cours</span>
                                                </div>
                                                <div> </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

import ProtractorService from './ProtractorService.js';
import Edit from '../../../layouts/Edit.vue';

export default {
    extends: Edit,
    data () {
        return {
            resource: {
                addressable: []
            },
            entity: null
        }
    },
    mounted: function(){
    },
    methods:{
        resourceLoaded: function(){
            this.localesLoaded = true;
            this.resource.links = this.resource.links || [];
            this.initialize()
        },
        getResource: function(){
            return ProtractorService
        },
        updateEntity: function(item)
        {
            if( item && item.entity )
            {
                this.resource.client_type = item.type
                this.resource.client_id = item.entity.id
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/modules/serevita/protractor/Edit.vue